import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { clearAdministrationRequestState } from "../../actions";
import { alertTypeConstants } from "../../constants/constants";
import localize, { LocKeys } from "../../constants/localizations";
import CustomSnackbar from "../../shared/CustomSnackbar/CustomSnackbar";

/**
 * Snackbar messages for admin panel
 * @param {*} props
 * @returns
 */
const AdministrationRequestPopups = (props) => {
	const {
		// Actions
		clearAdministrationRequestState,
		// From state
		request,
		action,
		successMessage,
		errorResponse,
		errorMessage,
	} = props;

	const [showError, setShowError] = useState(!action && request);
	const [showSuccess, setShowSuccess] = useState(action && request);

	useEffect(() => {
		if (request) {
			if (!action) {
				setShowError(true);
			} else {
				setShowSuccess(true);
			}
		}
	}, [action, request]);

	const errorOnClose = () => {
		setShowError(false);
		clearAdministrationRequestState();
	};

	const successOnClose = () => {
		setShowSuccess(false);
		clearAdministrationRequestState();
	};

	return (
		<>
			<CustomSnackbar
				open={showSuccess}
				onClose={successOnClose}
				title={localize(LocKeys.SUCCESS)}
			>
				{successMessage}
			</CustomSnackbar>
			<CustomSnackbar
				open={showError}
				onClose={errorOnClose}
				type={alertTypeConstants.ERROR}
				title={localize(LocKeys.ERROR)}
			>
				{errorResponse || errorMessage}
			</CustomSnackbar>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		action: state.getIn(["administration", "action"]),
		request: state.getIn(["administration", "request"]),
		errorResponse: state.getIn(["administration", "errorResponse"]),
		errorMessage: state.getIn(["administration", "errorMessage"]),
		successMessage: state.getIn(["administration", "successMessage"]),
	};
};
export default connect(mapStateToProps, { clearAdministrationRequestState })(
	AdministrationRequestPopups
);
